// removed by extract-text-webpack-plugin
module.exports = {"reviewsWrap":"qempo_Reviews_reviewsWrap-1nXyi9l","reviewsContent":"qempo_Reviews_reviewsContent-2WreHSh","reviewWrap":"qempo_Reviews_reviewWrap-A0pSAeJ","topWrap":"qempo_Reviews_topWrap-1bdyFwL","imageWrap":"qempo_Reviews_imageWrap-3G6GzqA","contentWrap":"qempo_Reviews_contentWrap-2HGm-HC","starsWrap":"qempo_Reviews_starsWrap-1Vj_40F","full":"qempo_Reviews_full-Stp1x9V","empty":"qempo_Reviews_empty-bjhdDb3","comment":"qempo_Reviews_comment-23sgGV2"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/flight-landing/components/Reviews/Reviews.scss
// module id = 1720
// module chunks = 0